import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';
import { LanguageService } from '@core/services/language.service';
import { SemarComponentsModule } from '@shared/components/semar-components/semar-components.module';

@Component({
    selector: 'mcp-root',
    imports: [RouterOutlet, SemarComponentsModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.scss'],
    template: `
      <router-outlet />
      <mcp-semar-fab />
      <mcp-semar-chat-panel />
    `

})
export class AppComponent {
  // Instantiating ThemeService here ensures the persisted theme (clean/dark)
  // is applied to <body data-theme="..."> before any view paints.
  private themeService = inject(ThemeService);
  // Alasan yang sama untuk bahasa: LanguageService menetapkan bahasa aktif
  // Transloco dari localStorage sebelum view pertama dirender.
  private languageService = inject(LanguageService);
}
